import AppConstants from '../config/app.constants';

let VaultService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/vault`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/vault/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/vault/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/vault/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/vault/${id}`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get
    };
};

VaultService.$inject = ['$http', '$q']

export default VaultService;


// WEBPACK FOOTER //
// ./client/app/services/vault.service.js